import { useGetAssessmentResult } from "@/api/app/assessment-result/useGetAssessmentResult";
import LoadingScreen from "@/components/Loading";
import { Button } from "@/components/ui/button";
import { handlePrintPdf } from "@/lib/handlePrintPdf";
import AssessmentResult from "@/src/_components/AssessmentResult/AssessmentResult";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

function PaidAssessmentResultPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const isFirstTime = searchParams.get("isFirstTime") === "true";
  const { id = "" } = useParams();
  const { data, isLoading } = useGetAssessmentResult(id, isFirstTime);
  const [isPrinting, setPrinting] = useState(false);

  if (isLoading) {
    return <LoadingScreen />;
  }
  if (!data) {
    navigate("/app/assessment");
    return null;
  }

  return (
    <div className="h-full overflow-auto">
      <div className="flex justify-between px-16 py-4 border-b border-cool-gray-200">
        <span className="text-2xl font-bold">{t("assessment-result")}</span>
        <Button
          isLoading={isPrinting}
          variant="outline"
          onClick={() => {
            setPrinting(true);
            handlePrintPdf("assessment-result", "assessment-result", () => {
              setPrinting(false);
            });
          }}
        >
          {t("download-report")}
        </Button>
      </div>
      <AssessmentResult assessmentResult={data.data} />;
    </div>
  );
}

export default PaidAssessmentResultPage;
